export default {
  applies_to_articles: 'Applies to following items',
};
